
































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import DeliveryDriverResponse from '@/model/response/DeliveryDriverResponse'
import DeliveryDriverRequest from '@/model/request/DeliveryDriverRequest'
import FilterDeliveryDriver from '@/components/filters/FilterDeliveryDriver.vue'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryDriver.title'),
})
@Component({
  metaInfo,
  components: {FilterToggle, FilterDeliveryDriver},
})
export default class ReportsDeliveryDriverView extends Mixins(MixinFilter) {

  filter = new DeliveryDriverRequest()
  collection = new PageCollection(DeliveryDriverResponse, this.filter, 10 )

  AppConfig = AppConfig

  async created() {
    this.collection.orderBy = 'nome'
    this.collection.asc = true
  }

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
        const csv = new PageCollection(DeliveryDriverResponse, this.filter, null, null)

        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'download')
        csv.downloadCsv(snakeCase($.t('view.reports.deliveryDriver.title')))
    } else {
        await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.deliveryDriver.title'),
          new DeliveryDriverResponse().$endpoint,
          this.filter,
          DeliveryDriverResponse,
          'DeliveryDriverResponse',
          ), 'download')
    }
  }
}
